import React from "react";
import { useNavigate } from "react-router-dom";

const HomeAboutUs = ({ labelDetailData }) => {
  const navigate = useNavigate();

  const { aboutUsTitle, aboutUsHeading, aboutUsSubHeading } =
    React.useMemo(() => {
      const data = labelDetailData?.code === 200 ? labelDetailData.data : [];
      const getLabel = (key) =>
        data?.find((item) => item.vLabel === key)?.tText || "";

      return {
        aboutUsTitle: getLabel("LBL_HOME_ABOUT_AS_HEADING"),
        aboutUsHeading: getLabel("LBL_HOME_ABOUT_AS_SUB_HEADING"),
        aboutUsSubHeading: getLabel("LBL_HOME_ABOUT_AS_DESCRIPTION"),
      };
    }, [labelDetailData]);

  const handleBookNowForm = () => navigate("/book-now");

  return (
    <section className="aboutus-section ptb-100">
      <div className="container">
        <div className="row align-items-center responsive-aboutrow">
          <div className="col-lg-6">
            <div className="about-contentDiv">
              {aboutUsTitle && (
                <span className="small-title">{aboutUsTitle}</span>
              )}
              {aboutUsHeading && (
                <h2 className="main-title">{aboutUsHeading}</h2>
              )}
              {aboutUsSubHeading && <p>{aboutUsSubHeading}</p>}
              <button
                className="success-orangebtn"
                type="button"
                onClick={handleBookNowForm}
              >
                Book Now
              </button>
            </div>
          </div>
          <div className="col-lg-6">
            <img
              className="about-mainimg"
              // src="/assets/images/about-img.png"
              // src="/assets/images/about-img.webp"
              src="/assets/images/about-img-new.webp"
              width="535"
              height="467"
              // width="655"
              // height="516"
              alt="About Us"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeAboutUs;
